export * from "./login.service";
export * from "./register.service";
export * from "./users.service";
export * from "./chapter.service";
export * from "./finance.service";
export * from "./message.service";
export * from "./product.service";
export * from "./qus-ans.service";
export * from "./semester.service";
export * from "./student.service";
export * from "./subject.service";
export * from "./university.service";
export * from "./message.service";


// WEBPACK FOOTER //
// ./src/app/service/index.ts